var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCloseBold = function SvgCloseBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.284 4.75l-10.5 10.5M4.784 4.75l10.5 10.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjAnIGhlaWdodD0nMjAnIHZpZXdCb3g9JzAgMCAyMSAyMCcgZmlsbD0nbm9uZScgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz4KICA8cGF0aAogICAgZD0nTTE1LjI4NDUgNC43NUw0Ljc4NDQ4IDE1LjI1JwogICAgc3Ryb2tlPSdjdXJyZW50Q29sb3InCiAgICBzdHJva2Utd2lkdGg9JzEuNScKICAgIHN0cm9rZS1saW5lY2FwPSdyb3VuZCcKICAgIHN0cm9rZS1saW5lam9pbj0ncm91bmQnCiAgLz4KICA8cGF0aAogICAgZD0nTTQuNzg0NDggNC43NUwxNS4yODQ1IDE1LjI1JwogICAgc3Ryb2tlPSdjdXJyZW50Q29sb3InCiAgICBzdHJva2Utd2lkdGg9JzEuNScKICAgIHN0cm9rZS1saW5lY2FwPSdyb3VuZCcKICAgIHN0cm9rZS1saW5lam9pbj0ncm91bmQnCiAgLz4KPC9zdmc+";
export { SvgCloseBold as ReactComponent };